import type {ReactElement} from 'react';
import React from 'react';
import {StylesInputPanel} from '@Panels/styles-input-panel/styles-input-panel';
import type {StylesInputLeftDrawerProps} from './styles-input-left-drawer.types';
import {noop} from '@Utils/general.util';
import {Drawer} from '@Components/drawer/drawer';

export function StylesInputLeftDrawer({isOpen, className = '', ...panelProps}: StylesInputLeftDrawerProps): ReactElement<StylesInputLeftDrawerProps> {
  return (
    <Drawer isOpen={isOpen} onClose={panelProps.onClose ?? noop} className={className}>
      <StylesInputPanel {...panelProps} />
    </Drawer>
  );
}
